import { useEffect, useRef, useState } from "react";

interface EngagementTrackerProps {
  data?: any;
  context: string;
  meta?: any;
  trigger?: any;
  onSync?: (x: any) => Promise<void>;
}

const useEngagementTracker = (props: EngagementTrackerProps) => {
  const { data, context, meta, trigger, onSync } = props;
  const [id, setId] = useState(null);
  const idRef = useRef(id);
  const dataRef = useRef(data);
  const metaRef = useRef(meta);
  const mountTime = useRef<Date | null>(null);

  const handleSync = async () => {
    const engagementId: any = await onSync?.({
      data: {
        ...dataRef.current,
        id: idRef.current ?? id ?? null,
      },
      duration: mountTime.current ? new Date().getTime() - mountTime.current.getTime() : 0,
      meta: {
        ...metaRef.current,
        context,
      }, 
    });
    if (engagementId) {
      idRef.current = engagementId;
      setId(engagementId);
    }
  };

  useEffect(() => {
    handleSync();
  }, [trigger]);

  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  useEffect(() => {
    metaRef.current = meta;
  }, [meta]);
  

  useEffect(() => {
    mountTime.current = new Date();

    return () => {
      handleSync();
    };
  }, []);

  return {
    engagementId: id,
    data: dataRef.current,
    duration: mountTime.current ? new Date().getTime() - mountTime.current.getTime() : 0,
    meta,
  };
};

useEngagementTracker.defaultProps = {
  data: null,
};

export default useEngagementTracker;
